import { ReceiptIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';

import { InvoiceCard } from './invoice-card';
import type { Invoice } from './types';

interface Props {
  invoices: Invoice[];
  onSelect: (invoice: Invoice) => void;
}

export function InvoicesGrid({ invoices, onSelect }: Props) {
  const { t } = useLanguage();

  if (invoices.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3 text-center border rounded-xl bg-card">
        <ReceiptIcon className="w-10 h-10 text-muted-foreground/40" />
        <p className="font-medium text-sm">{t.noInvoicesFound}</p>
        <p className="text-xs text-muted-foreground">{t.noInvoicesDescription}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {invoices.map((invoice) => (
        <InvoiceCard key={invoice.id} invoice={invoice} onSelect={onSelect} />
      ))}
    </div>
  );
}
